import crownV2 from "assets/crownV2.png";
import CountdownV2 from "components/CountdownV2";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import usePopUpsV2 from "components/PopUpManagerV2/hooks/usePopUpsV2";
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import { PurchaseOffers } from "contexts/WebStoreProvider/types";
import { useAppSelector } from "hooks";
import useRewardsById from "hooks/useRewardsById";
import { sortBundleRewards } from "helpers/rewardSort";
import { useEffect, useMemo } from "react";
import { offersApi } from "redux/apis";
import { selectBundleUpState } from "redux/slices";
import {
	Container,
	CustomButtom,
	DataContainer,
	InfoContainer,
	ItemImage,
	Items,
	LoyaltyContainer,
	LoyaltyPoints,
	OfferItem,
	RewardAmount,
	RewardAmountContainer,
	RewardItem,
	SubTitle,
	Title
} from "./styles";

interface BundleUpInfoProps {
	id: string;
}
export const BundleUpInfo = ({ id }: BundleUpInfoProps) => {
	const { close } = usePopUpsV2();
	const { nowTime } = useWebStoreContext();
	const scale = useCalculateScale(396 + 40, 414 + 40);
	const { authToken } = useWebStoreContext();
	const { endTime } = useAppSelector(selectBundleUpState);
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const {
		data: purchaseOffers
	}: {
		data?: PurchaseOffers;
	} = offersApi.endpoints.getOffers.useQueryState({
		offerType: "singleItem",
		isAuthenticated: !!authToken?.value
	});
	const { data: featuredDealsData } =
		offersApi.endpoints.getOffers.useQueryState({
			offerType: "featured",
			isAuthenticated: !!authToken?.value
		});

	const offerData = useMemo(() => {
		const offers =
			purchaseOffers?.offers?.concat(featuredDealsData?.offers) || [];
		return offers.find((o) => o.id === id);
	}, [purchaseOffers, featuredDealsData, id]);

	const rewards = useRewardsById(offerData?.rewardId as string);

	const handleOnEnd = () => {
		setTimeout(() => {
			close({ variant: `bundle-up-info::${id}` });
		}, 1000);
	};

	const onClose = () => {
		close({ variant: `bundle-up-info::${id}` });
	};

	useEffect(() => {
		reportEvent("dialog_shown", {
			source: "bundle_up_info",
			base_offer_id: id
		});
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "dialog_shown",
			event_type: "web_bundle_up",
			action: "dialog_shown",
			source: "bundle_up_info",
			offer_id: id
		});
	}, []);

	return (
		<Container scale={scale}>
			{/* <CloseIconButton onClose={onClose} /> */}
			{endTime && (
				<CountdownV2
					text="Ends in:"
					startTime={nowTime}
					endTime={endTime}
					onEnd={handleOnEnd}
					style={{
						fontSize: "0.8em",
						margin: "0em 0.36em",
						padding: "0.3em 0.5em"
					}}
					iconStyle={{ width: "1.5em", height: "1.5em" }}
				/>
			)}
			<Title>{offerData?.description}</Title>
			<DataContainer>
				<OfferItem>
					<Items>
						{sortBundleRewards(rewards).map((reward, key) => {
							return (
								<RewardItem key={key} width={100 / rewards.length + "%"}>
									<ItemImage src={reward.imageUrl} alt="" />
									<RewardAmountContainer>
										<RewardAmount>{reward.description}</RewardAmount>
									</RewardAmountContainer>
								</RewardItem>
							);
						})}
					</Items>
				</OfferItem>
				<SubTitle>You also get:</SubTitle>
				<LoyaltyContainer>
					<ItemImage className="crown" src={crownV2} />
					<InfoContainer>
						<LoyaltyPoints>
							{offerData?.loyaltyPointReward} Loyalty Points
						</LoyaltyPoints>
					</InfoContainer>
				</LoyaltyContainer>
				<CustomButtom
					variant="contained"
					themeColor="secondary"
					color="secondary"
					onClick={onClose}
				>
					{" "}
					Go Back
				</CustomButtom>
			</DataContainer>
		</Container>
	);
};
